import { getBrandLogoName } from '~utils/brand'
import { renderBrandLogo, brandLogos } from '~globalComponents/BrandList/utils'

export const useBrandLogo = (brand) => {
  const brandName = getBrandLogoName(brand)

  return renderBrandLogo({ brandLogos, brand, brandName })
}
